import { Outlet } from "react-router-dom";
import { Unauthorized } from "@/pages/static";
import { useUser } from "@/context/UserContext";

const PermissionGuard = ({ permission }) => {
    const { hasPermission } = useUser();

    if (!hasPermission(permission)) {
        return <Unauthorized />;
    }

    return <Outlet />;
};

export default PermissionGuard;
